import GradientBorderRadius from "@/ui/gradient-border-radius";
import Input from "@/ui/input";

import { useToken } from "@/pages/token-v2/hooks/use-token";
import { IconComponent, IconsTypes } from "@/ui/icon";
import { formatDecimalStringFloat } from "@/utils/currency";

const YouReceiveTokenUsdInput = ({
  youReceive,
  youReceiveUSD,
  onYouReceiveChange = () => {},
  onYouReceiveUSDChange = () => {},
}: {
  youReceive: string;
  youReceiveUSD: string;
  onYouReceiveChange?: (v: string) => void;
  onYouReceiveUSDChange?: (v: string) => void;
}) => {
  const token = useToken();
  const chainIcon = (
    (token?.pair?.networkId ?? 1) === 1 ? "ethereum" : "solana"
  ) as IconsTypes;

  return (
    <GradientBorderRadius
      radius="medium"
      className="mt-[0.313rem]"
      gradient="default-border"
    >
      <div className="px-[0.625rem] py-[0.4rem] flex flex-col gap-y-[0.275rem]">
        <span className="text-xs font-semibold">Receive</span>
        <div className="flex items-center justify-between">
          <Input
            activeWhenInputIsNotEmpty={false}
            value={youReceive}
            gradient="none"
            hover="none"
            placeholder="0"
            gradientClassName="focus-within:before:bg-none"
            className="!h-[1.375rem]"
            onChange={(v) => {
              const formattedValue = formatDecimalStringFloat(
                v,
                true,
                false,
                8
              );

              onYouReceiveChange(formattedValue);
            }}
            leftSide={
              <div className="w-[1.375rem] h-[1.375rem] flex items-center justify-center">
                <Input.Accordion>
                  <IconComponent
                    className="w-[1.375rem] h-[1.375rem]"
                    name={chainIcon as IconsTypes}
                  />
                </Input.Accordion>
              </div>
            }
          />
          <div className="text-xs flex items-center gap-[0.188rem]">
            <span className="font-semibold">Value:</span>{" "}
            <div
              className="h-[1.375rem] text-xs"
              style={{
                width: `clamp(1.15rem, ${1.15 + (String(youReceiveUSD).length - 1) * 0.5}rem, 3.5rem)`,
              }}
            >
              <Input
                activeWhenInputIsNotEmpty={false}
                value={youReceiveUSD}
                className="!h-[1.375rem] w-auto !pl-[0.125rem] border-none text-end"
                gradient="none"
                hover="none"
                placeholder="0"
                gradientClassName="focus-within:before:bg-none"
                onChange={(v) => {
                  const formattedValue = formatDecimalStringFloat(
                    v,
                    true,
                    false,
                    4
                  );

                  onYouReceiveUSDChange(formattedValue);
                }}
                leftSide={
                  <div className="h-full">
                    <Input.Accordion>$</Input.Accordion>
                  </div>
                }
              />
            </div>
          </div>
        </div>
      </div>
    </GradientBorderRadius>
  );
};

export default YouReceiveTokenUsdInput;
